<template>
  <div class="customStatistics">
    <headerNotice routerName="客户订货统计"></headerNotice>
    <div class="content" v-loading="loading">
      <div class="header">
        <dateSelector @dateChange="getDataByTime"/>
        <!-- <div class="export">
          <el-button type="text" style="color: #000;">
            统计说明
            <i class="el-icon-question"></i>
          </el-button>
          <el-button type="text" style="color: #000;">
            <i class="el-icon-printer"></i>
            导出
          </el-button>
        </div>-->
      </div>
      <h1 class="title">订货单</h1>
      <el-row style="padding: 10px 0;">
        <el-col>
          <el-select @change="getDataByMan" v-model="salesmanId">
            <el-option label="全部业务员" :value="0"></el-option>
            <el-option
              v-for="item in memberList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <sum-list :list="dataSum"/>
      <div id="myChart" style="width: 100%;height:400px; margin-top: 20px;"></div>
      <h1 class="title">详细数据</h1>
      <el-table
        :data="customData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column align="center" prop="customerName" label="客户名称"></el-table-column>
        <el-table-column align="center" prop="orderCount" label="订货单数" sortable></el-table-column>
        <el-table-column align="center" prop="orderAmount" label="订货金额(￥)" sortable></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync='currentPage'
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        center
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import dateSelector from "./dateSelector.vue";
import sumList from "./sumList.vue";
import echarts from "echarts";
export default {
  components: {
    headerNotice,
    sumList,
    dateSelector
  },
  props: {},
  data() {
    return {
      loading: false,
      pageSize: 10,
      totalCount: 0,
      currentPage: 1,
      duration: [],
      salesmanId: 0,
      customData: [],
      dataSum: [],
      chartData: {},
      memberList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    getMemberList(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetList",
        params: params,
        success(res) {
          // console.log(res);
          self.memberList = self.dealMemberList(res);
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 提取员工列表
    dealMemberList(list) {
      var temp = [];
      list.items.forEach(item => {
        temp.push({
          label: item.realName,
          value: item.userId
        });
      });
      // console.log(temp)
      return temp;
    },
    // 更改时间重新发请求
    getDataByTime(date) {
      this.duration = date;
      this.GetStatisticsByCutomer({
        StartTime: date[0],
        EndTime: date[1],
        SalesmanId: this.salesmanId,
        MaxResultCount: this.pageSize
      });
      this.currentPage = 1
    },
    // 更改员工发送请求
    getDataByMan() {
      this.GetStatisticsByCutomer({
        StartTime: this.duration[0],
        EndTime: this.duration[1],
        SalesmanId: this.salesmanId,
        MaxResultCount: this.pageSize
      });
      this.currentPage = 1
    },
    // 订单数据
    GetStatisticsByCutomer(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/GetStatisticsByCutomer",
        params: params,
        success(res) {
          // console.log(res)
          self.customData = res.items;
          self.totalCount = res.totalCount;
          self.chartData = self.initChartData(res);
          self.dataSum = self.getDataSum(res);
          self.initChart();
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 总数据
    getDataSum(data) {
      return [
        { title: "订货单数", value: data.totalOrderNum },
        { title: "订货客户", value: data.totalOrderedCustomerNum },
        { title: "订货金额", value: data.totalOrderedAmountNum }
      ];
    },
    // 图表数据处理
    initChartData(data) {
      var temp = {
        x_name: [],
        yl_amount: [],
        yr_percent: []
      };
      data.items.forEach(item => {
        temp.yl_amount.push(item.orderAmount);
        temp.yr_percent.push(
          +((item.orderAmount / data.totalOrderedAmountNum) * 100).toFixed(2)
        );
        temp.x_name.push(item.customerName);
      });
      // console.log(temp);
      return temp;
    },
    initChart() {
      var myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ["订单金额", "占比%"]
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        // dataZoom: {
        //   show: false,
        //   start: 0,
        //   end: 100
        // },
        xAxis: [
          {
            type: "category",
            // boundaryGap: true,
            // axisLine: { onZero: false },
            data: this.chartData.x_name,
            axisLabel: {
              formatter: (value, index) => {
                if (value.length > 5) {
                  value = value.slice(0, 5) + "...";
                }
                return value;
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            // scale: true,
            name: "订单金额/元",
            max: Math.max.apply({}, this.chartData.yl_amount),
            min: 0
            // boundaryGap: [0.2, 0.2]
          },
          {
            type: "value",
            // scale: true,
            name: "占比%",
            max: 100,
            min: 0
            // boundaryGap: [0.2, 0.2]
          }
        ],
        series: [
          {
            name: "订单金额",
            type: "bar",
            barWidth: "10%",
            animation: false,
            data: this.chartData.yl_amount
          },
          {
            name: "占比%",
            type: "line",
            yAxisIndex: 1,
            animation: false,
            data: this.chartData.yr_percent
          }
        ]
      });
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val,
        StartTime: this.duration[0],
        EndTime: this.duration[1],
        SalesmanId: this.salesmanId
      };
      this.GetStatisticsByCutomer(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      let skipCount = (val - 1) * this.pageSize;
      let params = {
        SkipCount: skipCount,
        MaxResultCount: this.pageSize,
        StartTime: this.duration[0],
        EndTime: this.duration[1],
        SalesmanId: this.salesmanId
      };
      this.GetStatisticsByCutomer(params);
    }
  },
  created() {
    this.getMemberList({
      MaxResultCount: 9999,
      SkipCount: 0
    });
  },
  mounted() {
    // this.initChart();
  }
};
</script>
<style lang="scss" scoped>
.customStatistics {
  .content {
    padding: 0 50px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  .title {
    padding-left: 20px;
    background: #f3f3f3;
    line-height: 50px;
  }
  .pagination-wrapper {
    text-align: center;
    margin: 30px auto;
  }
}
</style>